// src/hooks/useSmartNavigate.ts
import { useNavigate } from 'react-router-dom';
import type { NavigateOptions } from 'react-router-dom';
import { isMobileDevice } from '../utils/device';

export function useSmartNavigate() {
  const navigate = useNavigate();

  return (to: string, options?: NavigateOptions) => {
    const mobile = isMobileDevice();
    let path = to;

    // 상대 경로 들어올 수 있으니까 안전하게 처리
    if (!path.startsWith('/')) {
      path = '/' + path;
    }

    if (mobile) {
      // 모바일인데 /m 없으면 자동으로 /m 붙이기
      if (!path.startsWith('/m')) {
        path = '/m' + path;
      }
    } else {
      // PC인데 /m 붙어있으면 제거
      if (path.startsWith('/m')) {
        path = path.replace(/^\/m/, '') || '/';
      }
    }

    navigate(path, options);
  };
}
